<template>
    <div class="messages">
        <h5 class="f-title">
            {{word.all_chats}}
        </h5>

        <div class="message-box">
            <chats :user-id="userId" />

            <messages :user-id="userId"/>
        </div>
    </div>
</template>

<script>
    import Chats from './Chats';
    import Messages from './Messages';
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        name: "chat-container",

        props: [
            'userId'
        ],
        data(){
            return {
                word: window.word,
                text: window.text,
            }
        },

        components: {
            Chats,
            Messages,
            Loading
        }
    }
</script>
